import { render, staticRenderFns } from "./GetQrCode.vue?vue&type=template&id=23d0c058&scoped=true"
import script from "./GetQrCode.vue?vue&type=script&lang=js"
export * from "./GetQrCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d0c058",
  null
  
)

export default component.exports